module.exports = __webpack_public_path__ + "static/media/dong-result.5ee4c700.png";